import { useLocation } from 'react-router-dom';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsContentPageContainerLoadable } from 'modules/cms/pages/Content';
import { SearchPageContainerLoadable } from 'modules/main/pages/Search';
import { MainStoreContentsState } from 'modules/main/store/ducks/contents';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { useAmpContext } from 'utils/AmpContext';
import { hasParam } from 'utils/url';

export function MainCmsPage() {
  const isAmp = useAmpContext();
  const location = useLocation();

  const prefix = isAmp ? /^\/amp\// : /^\//;
  const slug = location.pathname.replace(prefix, '');

  const content = useMainSelector(
    (state) => state?.contents as MainStoreContentsState | undefined,
  )?.byUrl?.[slug] as CmsApiPage | undefined;

  const isLandingPage =
    (content &&
      ['CMS_SEARCH_LANDING_PAGE', 'LANDING_PAGE'].includes(content.type)) ||
    false;

  const { redirectToContent = false }: { redirectToContent?: boolean } =
    location.state || {};

  if (
    hasParam(location.search, 'q') ||
    hasParam(location.search, 'pq') ||
    isLandingPage
  ) {
    if (redirectToContent) {
      return <CmsContentPageContainerLoadable slug={slug} amp={isAmp} />;
    }

    return <SearchPageContainerLoadable slug={slug} amp={isAmp} />;
  }

  return <CmsContentPageContainerLoadable slug={slug} amp={isAmp} />;
}
